import React from "react";
import {CCChart} from "../CCChart";

// Shared scaffold for EC-backed MUI x-charts components.
//
// Subclasses provide:
//   static ATTR_MAP — array of [PascalCaseAttr, camelCaseMuiProp] pairs
//   renderChart(chartProps) — returns the MUI element with the chartProps spread in
//
// State is limited to fields that EC callbacks actually mutate post-mount
// (Series, axes, Loading). Everything else flows from props at render time —
// avoids the silent-typo class of bug where a mistyped state key drops a prop.
//
// `extends (CCChart as any)` widens this.state/this.props/this.constructor to
// `any` so the EC-driven state mutation pattern (this.state.Series = ...)
// typechecks under strict mode without per-line casts. Subclasses inherit
// the loose typing automatically.
class CCMuiChart extends (CCChart as any) {
    static ATTR_MAP: [string, string][] = [];

    constructor(props: any) {
        super(props);

        this.state.Series = props.Series ?? [];
        this.state.xAxis = props.xAxis;
        this.state.yAxis = props.yAxis;
        this.state.zAxis = props.zAxis;
        this.state.Loading = props.attributes?.Loading;
    }

    renderChart(_chartProps: any): React.ReactNode {
        throw new Error(`${this.constructor.name} must implement renderChart(chartProps)`);
    }

    render(): React.ReactNode {
        const a = this.props.attributes ?? {};
        const muiProps: any = {};
        for (const [src, dst] of (this.constructor as any).ATTR_MAP) {
            if (a[src] !== undefined) muiProps[dst] = a[src];
        }

        const chartProps: any = {
            ...muiProps,
            series: this.state.Series,
        };
        const loading = this.state.Loading ?? muiProps.loading;
        if (loading !== undefined) chartProps.loading = loading;
        if (this.state.xAxis !== undefined) chartProps.xAxis = this.state.xAxis;
        if (this.state.yAxis !== undefined) chartProps.yAxis = this.state.yAxis;
        if (this.state.zAxis !== undefined) chartProps.zAxis = this.state.zAxis;

        return this.renderChart(chartProps);
    }
}

export default CCMuiChart;
